import { useMemo } from "react";
import { Empty, Grid } from "antd";
import { useJourneyDynamicDetails, useJourneyStaticDetails } from "../../../../context";
import { explode } from "src/utility";
import { getSeatMapping } from "../../utils";
import { useSSRContext } from "../../context/SSRContext";
import Legend from "./components/Legend/Legend";
import SeatSymbolDefs from "./components/SeatIcon/SeatSymbolDefs";
import { PLANE_SEATING_LEGEND, SeatType } from "src/Modules/Flights/constants/JourneyDetails";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import PlaneSeatingWeb from "./layouts/PlaneSeating.web";
import classNames from "classnames";
import PlaneSeatingScroll from "./layouts/PlaneSeatingScroll.mob";

const PlaneSeatingComponent = withConditionalComponent(PlaneSeatingWeb, PlaneSeatingScroll);

export default function PlaneSeating() {
  const { cursor, flightOptions, updateSSRItem } = useSSRContext();
  const { journeyDetails } = useJourneyStaticDetails();
  const { passengersState } = useJourneyDynamicDetails();
  const [passengers] = passengersState;
  const { data } = explode(journeyDetails, {});
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const flightSelected = flightOptions?.find((option) => option.value === cursor.flightId);
  const rows = data
    ? data?.ssr?.seatDynamic?.[flightSelected?.segmentIndex ?? 0]?.segmentSeat[flightSelected?.flightIndex ?? 0]?.rowSeats
    : [];
  const { colMap } = useMemo(
    () => getSeatMapping(rows ?? []) ?? { colMap: new Map(), gapsTotal: 0, seatsCount: 0 },
    [rows],
  );
  const handleClick = (val: SeatType) => {
    updateSSRItem("seats", val);
  };
  const craftType = rows?.[0]?.seats?.[0]?.craftType;
  const reservedSeats = passengers.passengers
    ?.map((pas) => pas?.segments[flightSelected?.segmentIndex])
    ?.flatMap((flights) => flights?.flights[flightSelected?.flightIndex ?? 0])
    ?.flatMap((addition) => Object.keys(addition?.ssr?.seats ?? {}));
  const isEmpty = !rows?.length;

  if (isEmpty)
    return (
      <div className="flex w-full items-center justify-center">
        <Empty />
      </div>
    );

  return (
    <div className="flex w-full flex-1 flex-col gap-4">
      <SeatSymbolDefs />
      <Legend
        items={PLANE_SEATING_LEGEND}
        dense={!isLargeScreen}
        className={classNames("sticky bg-background-default z-20" ,isLargeScreen ? "top-0" : "top-14")}
      />
      <PlaneSeatingComponent
        trigger={isLargeScreen}
        props={{
          colMap,
          rows,
          craftType,
          reservedSeats,
          onClick: handleClick,
          flightId: cursor.flightId,
        }}
      />
    </div>
  );
}
